<template>
  <div
    class="bg-gradient-to-b from-[--gradientFrom] to-[30vh] transition-all"
    :style="{ '--gradientFrom': gradientColor }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { ALL_CATALOG_ENTRY_COLOR } from "~/business-areas/tag-page/tag-page.model";

const properties = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: ALL_CATALOG_ENTRY_COLOR,
  },
);

const gradientColor = computed(() => {
  return hexToHSLA(properties.color, { saturation: 52, luminance: 96 });
});
</script>
